import { Component, OnInit } from '@angular/core';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { ApiService, UtilsService } from 'src/app/services';

@Component({
  selector: 'app-share',
  templateUrl: './share.page.html',
  styleUrls: ['./share.page.scss'],
})
export class SharePage implements OnInit {
  link: string = null;
  title = '';

  constructor(
    public modalCtrl: ModalController,
    private toastCtrl: ToastController,
    public nav:NavController
  ) { }

  async ngOnInit() {
    if (!this.link) {
      const props = JSON.parse(localStorage.getItem('propsShare')!);
      this.link = props.link;
      this.title = props.title ?? 'Запросити';
    }
  }

  async copy() {
    navigator.clipboard.writeText(this.link);
    await (await this.toastCtrl.create({ message: 'Посилання на заклад скопійвано', duration: 1500 })).present();
  }

}

